'use client';
import { MdOutlineFeedback } from 'react-icons/md';
import Button from './Button';
import { cn } from '@/lib/utils';
import {
  CreateFeedbackFormState,
  FEEDBACK_OPTIONS,
} from '@/lib/definitions/feedback';
import { useActionState, useState } from 'react';
import { actionCreateFeedback } from '@/actions/feedback/feedbacks';
import { FiX } from 'react-icons/fi';

export default function FeedbackButton() {
  const [showForm, setShowForm] = useState(false);

  const initialState: CreateFeedbackFormState = {
    error: '',
    values: {
      message: '',
      feedbackType: '',
    },
  };

  const [state, formAction, pending] = useActionState(
    actionCreateFeedback,
    initialState
  );

  function toggleShowForm() {
    setShowForm(!showForm);
  }

  return (
    // <div className="absolute bg-red-300 w-dvw h-dvh -z-10">
    <div className={cn('absolute z-50 p-2', 'bottom-14 sm:bottom-4 right-0')}>
      <div
        className={cn(
          'relative bg-card border border-border shadow-lg p-2 mb-12 rounded-2xl',
          !showForm && 'hidden'
        )}
      >
        <button
          type="button"
          onClick={() => setShowForm(false)}
          className="absolute w-min -top-2 -right-1 z-20 bg-muted hover:bg-accent text-foreground p-2 rounded-full cursor-pointer border border-border"
        >
          <FiX />
        </button>
        <div className="absolute -bottom-1 right-4 w-4 h-4 bg-card border-r border-b border-border rotate-45 -z-1" />
        <form
          action={formAction}
          className="p-4 bg-card rounded-lg sm:w-md sm:h-80"
        >
          <div className="w-full flex flex-col mb-4">
            <label htmlFor="title" className="font-semibold text-muted-foreground">
              Tipo
            </label>
            <select
              id="feedbackType"
              name="feedbackType"
              className="border border-input rounded-lg p-2 bg-background text-foreground"
            >
              {FEEDBACK_OPTIONS.map((item, index) => (
                <option key={index} value={item.value}>
                  {item.label}
                </option>
              ))}
            </select>
          </div>
          <label htmlFor="description" className="font-semibold text-muted-foreground">
            Mensagem
          </label>
          <textarea
            id="message"
            name="message"
            placeholder="Mensagem"
            className="border border-input p-2 rounded-lg w-full mb-4 sm:h-32 bg-background text-foreground"
          />

          <div className="flex justify-between gap-2">
            <Button
              onClick={() => setShowForm(false)}
              variant="secondary"
              type="button"
              className="rounded-lg"
            >
              Cancelar
            </Button>
            <Button className="rounded-lg">
              {pending ? 'Enviando' : 'Enviar'}
            </Button>
          </div>
          {state.success && (
            <div className="text-primary mt-2 flex flex-col items-center">
              <p>Feedback enviado!</p>
            </div>
          )}
          <div className="text-destructive pt-2">
            {state?.errors?.name && <p>* {state.errors.name}</p>}
            {state?.error && <p>* {state.error}</p>}
          </div>
        </form>
      </div>
      <Button
        className={cn(
          'w-min shadow-md absolute',
          'bottom-2 right-2'
        )}
        tooltip="Enviar feedback"
        onClick={toggleShowForm}
      >
        <MdOutlineFeedback className="text-2xl" />
      </Button>
    </div>
    // </div>
  );
}
